import { ISocialProvider } from './actions';
export var IFontTypes;
(function (IFontTypes) {
    IFontTypes["Roboto100"] = "Roboto Thin";
    IFontTypes["Roboto100italic"] = "Roboto Thin Italic";
    IFontTypes["Roboto300"] = "Roboto Light";
    IFontTypes["Roboto300italic"] = "Roboto Light Italic";
    IFontTypes["Roboto400"] = "Roboto Regular";
    IFontTypes["Roboto400italic"] = "Roboto Regular Italic";
    IFontTypes["Roboto500"] = "Roboto Medium";
    IFontTypes["Roboto500italic"] = "Roboto Medium Italic";
    IFontTypes["Roboto700"] = "Roboto Bold";
    IFontTypes["Roboto700italic"] = "Roboto Bold Italic";
    IFontTypes["Roboto900"] = "Roboto Black";
    IFontTypes["Roboto900italic"] = "Roboto Black Italic";
    IFontTypes["OpenSans300"] = "Open Sans Light";
    IFontTypes["OpenSans300italic"] = "Open Sans Light Italic";
    IFontTypes["OpenSans400"] = "Open Sans Regular";
    IFontTypes["OpenSans400italic"] = "Open Sans Regular Italic";
    IFontTypes["OpenSans500"] = "Open Sans Medium";
    IFontTypes["OpenSans500italic"] = "Open Sans Medium Italic";
    IFontTypes["OpenSans600"] = "Open Sans SemiBold";
    IFontTypes["OpenSans600italic"] = "Open Sans SemiBold Italic";
    IFontTypes["OpenSans700"] = "Open Sans Bold";
    IFontTypes["OpenSans700italic"] = "Open Sans Bold Italic";
    IFontTypes["OpenSans800"] = "Open Sans ExtraBold";
    IFontTypes["OpenSans800italic"] = "Open Sans ExtraBold Italic";
    IFontTypes["Montserrat100"] = "Montserrat Thin";
    IFontTypes["Montserrat100italic"] = "Montserrat Thin Italic";
    IFontTypes["Montserrat200"] = "Montserrat ExtraLight";
    IFontTypes["Montserrat200italic"] = "Montserrat ExtraLight Italic";
    IFontTypes["Montserrat300"] = "Montserrat Light";
    IFontTypes["Montserrat300italic"] = "Montserrat Light Italic";
    IFontTypes["Montserrat400"] = "Montserrat Regular";
    IFontTypes["Montserrat400italic"] = "Montserrat Regular Italic";
    IFontTypes["Montserrat500"] = "Montserrat Medium";
    IFontTypes["Montserrat500italic"] = "Montserrat Medium Italic";
    IFontTypes["Montserrat600"] = "Montserrat SemiBold";
    IFontTypes["Montserrat600italic"] = "Montserrat SemiBold Italic";
    IFontTypes["Montserrat700"] = "Montserrat Bold";
    IFontTypes["Montserrat700italic"] = "Montserrat Bold Italic";
    IFontTypes["Montserrat800"] = "Montserrat ExtraBold";
    IFontTypes["Montserrat800italic"] = "Montserrat ExtraBold Italic";
    IFontTypes["Montserrat900"] = "Montserrat Black";
    IFontTypes["Montserrat900italic"] = "Montserrat Black Italic";
    IFontTypes["Lato100"] = "Lato Thin";
    IFontTypes["Lato100italic"] = "Lato Thin Italic";
    IFontTypes["Lato300"] = "Lato Light";
    IFontTypes["Lato300italic"] = "Lato Light Italic";
    IFontTypes["Lato400"] = "Lato Regular";
    IFontTypes["Lato400italic"] = "Lato Regular Italic";
    IFontTypes["Lato700"] = "Lato Bold";
    IFontTypes["Lato700italic"] = "Lato Bold Italic";
    IFontTypes["Lato900"] = "Lato Black";
    IFontTypes["Lato900italic"] = "Lato Black Italic";
    IFontTypes["Poppins100"] = "Poppins Thin";
    IFontTypes["Poppins100italic"] = "Poppins Thin Italic";
    IFontTypes["Poppins200"] = "Poppins ExtraLight";
    IFontTypes["Poppins200italic"] = "Poppins ExtraLight Italic";
    IFontTypes["Poppins300"] = "Poppins Light";
    IFontTypes["Poppins300italic"] = "Poppins Light Italic";
    IFontTypes["Poppins400"] = "Poppins Regular";
    IFontTypes["Poppins400italic"] = "Poppins Regular Italic";
    IFontTypes["Poppins500"] = "Poppins Medium";
    IFontTypes["Poppins500italic"] = "Poppins Medium Italic";
    IFontTypes["Poppins600"] = "Poppins SemiBold";
    IFontTypes["Poppins600italic"] = "Poppins SemiBold Italic";
    IFontTypes["Poppins700"] = "Poppins Bold";
    IFontTypes["Poppins700italic"] = "Poppins Bold Italic";
    IFontTypes["Poppins800"] = "Poppins ExtraBold";
    IFontTypes["Poppins800italic"] = "Poppins ExtraBold Italic";
    IFontTypes["Poppins900"] = "Poppins Black";
    IFontTypes["Poppins900italic"] = "Poppins Black Italic";
    IFontTypes["Inter100"] = "Inter Thin";
    IFontTypes["Inter200"] = "Inter ExtraLight";
    IFontTypes["Inter300"] = "Inter Light";
    IFontTypes["Inter400"] = "Inter Regular";
    IFontTypes["Inter500"] = "Inter Medium";
    IFontTypes["Inter600"] = "Inter SemiBold";
    IFontTypes["Inter700"] = "Inter Bold";
    IFontTypes["Inter800"] = "Inter ExtraBold";
    IFontTypes["Inter900"] = "Inter Black";
    IFontTypes["Oswald200"] = "Oswald ExtraLight";
    IFontTypes["Oswald300"] = "Oswald Light";
    IFontTypes["Oswald400"] = "Oswald Regular";
    IFontTypes["Oswald500"] = "Oswald Medium";
    IFontTypes["Oswald600"] = "Oswald SemiBold";
    IFontTypes["Oswald700"] = "Oswald Bold";
    IFontTypes["Raleway100"] = "Raleway Thin";
    IFontTypes["Raleway100italic"] = "Raleway Thin Italic";
    IFontTypes["Raleway200"] = "Raleway ExtraLight";
    IFontTypes["Raleway200italic"] = "Raleway ExtraLight Italic";
    IFontTypes["Raleway300"] = "Raleway Light";
    IFontTypes["Raleway300italic"] = "Raleway Light Italic";
    IFontTypes["Raleway400"] = "Raleway Regular";
    IFontTypes["Raleway400italic"] = "Raleway Regular Italic";
    IFontTypes["Raleway500"] = "Raleway Medium";
    IFontTypes["Raleway500italic"] = "Raleway Medium Italic";
    IFontTypes["Raleway600"] = "Raleway SemiBold";
    IFontTypes["Raleway600italic"] = "Raleway SemiBold Italic";
    IFontTypes["Raleway700"] = "Raleway Bold";
    IFontTypes["Raleway700italic"] = "Raleway Bold Italic";
    IFontTypes["Raleway800"] = "Raleway ExtraBold";
    IFontTypes["Raleway800italic"] = "Raleway ExtraBold Italic";
    IFontTypes["Raleway900"] = "Raleway Black";
    IFontTypes["Raleway900italic"] = "Raleway Black Italic";
    IFontTypes["Rubik300"] = "Rubik Light";
    IFontTypes["Rubik300italic"] = "Rubik Light Italic";
    IFontTypes["Rubik400"] = "Rubik Regular";
    IFontTypes["Rubik400italic"] = "Rubik Regular Italic";
    IFontTypes["Rubik500"] = "Rubik Medium";
    IFontTypes["Rubik500italic"] = "Rubik Medium Italic";
    IFontTypes["Rubik600"] = "Rubik SemiBold";
    IFontTypes["Rubik600italic"] = "Rubik SemiBold Italic";
    IFontTypes["Rubik700"] = "Rubik Bold";
    IFontTypes["Rubik700italic"] = "Rubik Bold Italic";
    IFontTypes["Rubik800"] = "Rubik ExtraBold";
    IFontTypes["Rubik800italic"] = "Rubik ExtraBold Italic";
    IFontTypes["Rubik900"] = "Rubik Black";
    IFontTypes["Rubik900italic"] = "Rubik Black Italic";
    IFontTypes["Borel400"] = "Borel Regular";
    IFontTypes["Creepster400"] = "Creepster Regular";
    IFontTypes["Pacifico400"] = "Pacifico Regular";
    IFontTypes["ConcertOne400"] = "Concert One Regular";
    IFontTypes["Slabo27px400"] = "Slabo 27px Regular";
    IFontTypes["PressStart2P400"] = "Press Start 2P Regular";
    IFontTypes["AbrilFatface400"] = "Abril Fatface Regular";
    IFontTypes["BagelFatOne400"] = "Bagel Fat One Regular";
    IFontTypes["SourceCodePro200"] = "Source Code Pro ExtraLight";
    IFontTypes["SourceCodePro200italic"] = "Source Code Pro ExtraLight Italic";
    IFontTypes["SourceCodePro300"] = "Source Code Pro Light";
    IFontTypes["SourceCodePro300italic"] = "Source Code Pro Light Italic";
    IFontTypes["SourceCodePro400"] = "Source Code Pro Regular";
    IFontTypes["SourceCodePro400italic"] = "Source Code Pro Regular Italic";
    IFontTypes["SourceCodePro500"] = "Source Code Pro Medium";
    IFontTypes["SourceCodePro500italic"] = "Source Code Pro Medium Italic";
    IFontTypes["SourceCodePro600"] = "Source Code Pro SemiBold";
    IFontTypes["SourceCodePro600italic"] = "Source Code Pro SemiBold Italic";
    IFontTypes["SourceCodePro700"] = "Source Code Pro Bold";
    IFontTypes["SourceCodePro700italic"] = "Source Code Pro Bold Italic";
    IFontTypes["SourceCodePro800"] = "Source Code Pro ExtraBold";
    IFontTypes["SourceCodePro800italic"] = "Source Code Pro ExtraBold Italic";
    IFontTypes["SourceCodePro900"] = "Source Code Pro Black";
    IFontTypes["SourceCodePro900italic"] = "Source Code Pro Black Italic";
    IFontTypes["BebasNeue400"] = "Bebas Neue Regular";
    IFontTypes["PlayfairDisplay400"] = "Playfair Display Regular";
    IFontTypes["PlayfairDisplay400italic"] = "Playfair Display Regular Italic";
    IFontTypes["PlayfairDisplay500"] = "Playfair Display Medium";
    IFontTypes["PlayfairDisplay500italic"] = "Playfair Display Medium Italic";
    IFontTypes["PlayfairDisplay600"] = "Playfair Display SemiBold";
    IFontTypes["PlayfairDisplay600italic"] = "Playfair Display SemiBold Italic";
    IFontTypes["PlayfairDisplay700"] = "Playfair Display Bold";
    IFontTypes["PlayfairDisplay700italic"] = "Playfair Display Bold Italic";
    IFontTypes["PlayfairDisplay800"] = "Playfair Display ExtraBold";
    IFontTypes["PlayfairDisplay800italic"] = "Playfair Display ExtraBold Italic";
    IFontTypes["PlayfairDisplay900"] = "Playfair Display Black";
    IFontTypes["PlayfairDisplay900italic"] = "Playfair Display Black Italic";
    IFontTypes["RobotoSlab100"] = "Roboto Slab Thin";
    IFontTypes["RobotoSlab200"] = "Roboto Slab ExtraLight";
    IFontTypes["RobotoSlab300"] = "Roboto Slab Light";
    IFontTypes["RobotoSlab400"] = "Roboto Slab Regular";
    IFontTypes["RobotoSlab500"] = "Roboto Slab Medium";
    IFontTypes["RobotoSlab600"] = "Roboto Slab SemiBold";
    IFontTypes["RobotoSlab700"] = "Roboto Slab Bold";
    IFontTypes["RobotoSlab800"] = "Roboto Slab ExtraBold";
    IFontTypes["RobotoSlab900"] = "Roboto Slab Black";
    IFontTypes["Comfortaa300"] = "Comfortaa Light";
    IFontTypes["Comfortaa400"] = "Comfortaa Regular";
    IFontTypes["Comfortaa500"] = "Comfortaa Medium";
    IFontTypes["Comfortaa600"] = "Comfortaa SemiBold";
    IFontTypes["Comfortaa700"] = "Comfortaa Bold";
    IFontTypes["Cookie400"] = "Cookie Regular";
    IFontTypes["Philosopher400"] = "Philosopher Regular";
    IFontTypes["Philosopher400italic"] = "Philosopher Regular Italic";
    IFontTypes["Philosopher700"] = "Philosopher Bold";
    IFontTypes["Philosopher700italic"] = "Philosopher Bold Italic";
    IFontTypes["Quicksand300"] = "Quicksand Light";
    IFontTypes["Quicksand400"] = "Quicksand Regular";
    IFontTypes["Quicksand500"] = "Quicksand Medium";
    IFontTypes["Quicksand600"] = "Quicksand SemiBold";
    IFontTypes["Quicksand700"] = "Quicksand Bold";
    IFontTypes["Trirong100"] = "Trirong Thin";
    IFontTypes["Trirong100italic"] = "Trirong Thin Italic";
    IFontTypes["Trirong200"] = "Trirong ExtraLight";
    IFontTypes["Trirong200italic"] = "Trirong ExtraLight Italic";
    IFontTypes["Trirong300"] = "Trirong Light";
    IFontTypes["Trirong300italic"] = "Trirong Light Italic";
    IFontTypes["Trirong400"] = "Trirong Regular";
    IFontTypes["Trirong400italic"] = "Trirong Regular Italic";
    IFontTypes["Trirong500"] = "Trirong Medium";
    IFontTypes["Trirong500italic"] = "Trirong Medium Italic";
    IFontTypes["Trirong600"] = "Trirong SemiBold";
    IFontTypes["Trirong600italic"] = "Trirong SemiBold Italic";
    IFontTypes["Trirong700"] = "Trirong Bold";
    IFontTypes["Trirong700italic"] = "Trirong Bold Italic";
    IFontTypes["Trirong800"] = "Trirong ExtraBold";
    IFontTypes["Trirong800italic"] = "Trirong ExtraBold Italic";
    IFontTypes["Trirong900"] = "Trirong Black";
    IFontTypes["Trirong900italic"] = "Trirong Black Italic";
    IFontTypes["Trocchi400"] = "Trocchi Regular";
    IFontTypes["AdventPro100"] = "Advent Pro Thin";
    IFontTypes["AdventPro100italic"] = "Advent Pro Thin Italic";
    IFontTypes["AdventPro200"] = "Advent Pro ExtraLight";
    IFontTypes["AdventPro200italic"] = "Advent Pro ExtraLight Italic";
    IFontTypes["AdventPro300"] = "Advent Pro Light";
    IFontTypes["AdventPro300italic"] = "Advent Pro Light Italic";
    IFontTypes["AdventPro400"] = "Advent Pro Regular";
    IFontTypes["AdventPro400italic"] = "Advent Pro Regular Italic";
    IFontTypes["AdventPro500"] = "Advent Pro Medium";
    IFontTypes["AdventPro500italic"] = "Advent Pro Medium Italic";
    IFontTypes["AdventPro600"] = "Advent Pro SemiBold";
    IFontTypes["AdventPro600italic"] = "Advent Pro SemiBold Italic";
    IFontTypes["AdventPro700"] = "Advent Pro Bold";
    IFontTypes["AdventPro700italic"] = "Advent Pro Bold Italic";
    IFontTypes["AdventPro800"] = "Advent Pro ExtraBold";
    IFontTypes["AdventPro800italic"] = "Advent Pro ExtraBold Italic";
    IFontTypes["AdventPro900"] = "Advent Pro Black";
    IFontTypes["AdventPro900italic"] = "Advent Pro Black Italic";
    IFontTypes["HennyPenny400"] = "Henny Penny Regular";
    IFontTypes["Orbitron400"] = "Orbitron Regular";
    IFontTypes["Orbitron500"] = "Orbitron Medium";
    IFontTypes["Orbitron600"] = "Orbitron SemiBold";
    IFontTypes["Orbitron700"] = "Orbitron Bold";
    IFontTypes["Orbitron800"] = "Orbitron ExtraBold";
    IFontTypes["Orbitron900"] = "Orbitron Black";
    IFontTypes["Sacramento400"] = "Sacramento Regular";
    IFontTypes["SnowburstOne400"] = "Snowburst One Regular";
    IFontTypes["Syncopate400"] = "Syncopate Regular";
    IFontTypes["Syncopate700"] = "Syncopate Bold";
    IFontTypes["Wallpoet400"] = "Wallpoet Regular";
    IFontTypes["SirinStencil400"] = "Sirin Stencil Regular";
    IFontTypes["NotoSans100"] = "Noto Sans Thin";
    IFontTypes["NotoSans100italic"] = "Noto Sans Thin Italic";
    IFontTypes["NotoSans200"] = "Noto Sans ExtraLight";
    IFontTypes["NotoSans200italic"] = "Noto Sans ExtraLight Italic";
    IFontTypes["NotoSans300"] = "Noto Sans Light";
    IFontTypes["NotoSans300italic"] = "Noto Sans Light Italic";
    IFontTypes["NotoSans400"] = "Noto Sans Regular";
    IFontTypes["NotoSans400italic"] = "Noto Sans Regular Italic";
    IFontTypes["NotoSans500"] = "Noto Sans Medium";
    IFontTypes["NotoSans500italic"] = "Noto Sans Medium Italic";
    IFontTypes["NotoSans600"] = "Noto Sans SemiBold";
    IFontTypes["NotoSans600italic"] = "Noto Sans SemiBold Italic";
    IFontTypes["NotoSans700"] = "Noto Sans Bold";
    IFontTypes["NotoSans700italic"] = "Noto Sans Bold Italic";
    IFontTypes["NotoSans800"] = "Noto Sans ExtraBold";
    IFontTypes["NotoSans800italic"] = "Noto Sans ExtraBold Italic";
    IFontTypes["NotoSans900"] = "Noto Sans Black";
    IFontTypes["NotoSans900italic"] = "Noto Sans Black Italic";
    IFontTypes["NotoSerif100"] = "Noto Serif Thin";
    IFontTypes["NotoSerif100italic"] = "Noto Serif Thin Italic";
    IFontTypes["NotoSerif200"] = "Noto Serif ExtraLight";
    IFontTypes["NotoSerif200italic"] = "Noto Serif ExtraLight Italic";
    IFontTypes["NotoSerif300"] = "Noto Serif Light";
    IFontTypes["NotoSerif300italic"] = "Noto Serif Light Italic";
    IFontTypes["NotoSerif400"] = "Noto Serif Regular";
    IFontTypes["NotoSerif400italic"] = "Noto Serif Regular Italic";
    IFontTypes["NotoSerif500"] = "Noto Serif Medium";
    IFontTypes["NotoSerif500italic"] = "Noto Serif Medium Italic";
    IFontTypes["NotoSerif600"] = "Noto Serif SemiBold";
    IFontTypes["NotoSerif600italic"] = "Noto Serif SemiBold Italic";
    IFontTypes["NotoSerif700"] = "Noto Serif Bold";
    IFontTypes["NotoSerif700italic"] = "Noto Serif Bold Italic";
    IFontTypes["NotoSerif800"] = "Noto Serif ExtraBold";
    IFontTypes["NotoSerif800italic"] = "Noto Serif ExtraBold Italic";
    IFontTypes["NotoSerif900"] = "Noto Serif Black";
    IFontTypes["NotoSerif900italic"] = "Noto Serif Black Italic";
    IFontTypes["NotoSansJP100"] = "Noto Sans JP Thin";
    IFontTypes["NotoSansJP200"] = "Noto Sans JP ExtraLight";
    IFontTypes["NotoSansJP300"] = "Noto Sans JP Light";
    IFontTypes["NotoSansJP400"] = "Noto Sans JP Regular";
    IFontTypes["NotoSansJP500"] = "Noto Sans JP Medium";
    IFontTypes["NotoSansJP600"] = "Noto Sans JP SemiBold";
    IFontTypes["NotoSansJP700"] = "Noto Sans JP Bold";
    IFontTypes["NotoSansJP800"] = "Noto Sans JP ExtraBold";
    IFontTypes["NotoSansJP900"] = "Noto Sans JP Black";
    IFontTypes["NotoSansArabic100"] = "Noto Sans Arabic Thin";
    IFontTypes["NotoSansArabic200"] = "Noto Sans Arabic ExtraLight";
    IFontTypes["NotoSansArabic300"] = "Noto Sans Arabic Light";
    IFontTypes["NotoSansArabic400"] = "Noto Sans Arabic Regular";
    IFontTypes["NotoSansArabic500"] = "Noto Sans Arabic Medium";
    IFontTypes["NotoSansArabic600"] = "Noto Sans Arabic SemiBold";
    IFontTypes["NotoSansArabic700"] = "Noto Sans Arabic Bold";
    IFontTypes["NotoSansArabic800"] = "Noto Sans Arabic ExtraBold";
    IFontTypes["NotoSansArabic900"] = "Noto Sans Arabic Black";
    IFontTypes["NotoSansThai100"] = "Noto Sans Thai Thin";
    IFontTypes["NotoSansThai200"] = "Noto Sans Thai ExtraLight";
    IFontTypes["NotoSansThai300"] = "Noto Sans Thai Light";
    IFontTypes["NotoSansThai400"] = "Noto Sans Thai Regular";
    IFontTypes["NotoSansThai500"] = "Noto Sans Thai Medium";
    IFontTypes["NotoSansThai600"] = "Noto Sans Thai SemiBold";
    IFontTypes["NotoSansThai700"] = "Noto Sans Thai Bold";
    IFontTypes["NotoSansThai800"] = "Noto Sans Thai ExtraBold";
    IFontTypes["NotoSansThai900"] = "Noto Sans Thai Black";
    IFontTypes["NotoSansSC100"] = "Noto Sans SC Thin";
    IFontTypes["NotoSansSC300"] = "Noto Sans SC Light";
    IFontTypes["NotoSansSC400"] = "Noto Sans SC Regular";
    IFontTypes["NotoSansSC500"] = "Noto Sans SC Medium";
    IFontTypes["NotoSansSC700"] = "Noto Sans SC Bold";
    IFontTypes["NotoSansSC900"] = "Noto Sans SC Black";
    IFontTypes["NotoSansTC100"] = "Noto Sans TC Thin";
    IFontTypes["NotoSansTC300"] = "Noto Sans TC Light";
    IFontTypes["NotoSansTC400"] = "Noto Sans TC Regular";
    IFontTypes["NotoSansTC500"] = "Noto Sans TC Medium";
    IFontTypes["NotoSansTC700"] = "Noto Sans TC Bold";
    IFontTypes["NotoSansTC900"] = "Noto Sans TC Black";
    IFontTypes["NotoSansKR100"] = "Noto Sans KR Thin";
    IFontTypes["NotoSansKR300"] = "Noto Sans KR Light";
    IFontTypes["NotoSansKR400"] = "Noto Sans KR Regular";
    IFontTypes["NotoSansKR500"] = "Noto Sans KR Medium";
    IFontTypes["NotoSansKR700"] = "Noto Sans KR Bold";
    IFontTypes["NotoSansKR900"] = "Noto Sans KR Black";
})(IFontTypes || (IFontTypes = {}));
export var IUnitTypes;
(function (IUnitTypes) {
    IUnitTypes["pt"] = "pt";
    IUnitTypes["mm"] = "mm";
    IUnitTypes["cm"] = "cm";
    IUnitTypes["m"] = "m";
    IUnitTypes["inch"] = "inch";
    IUnitTypes["ft"] = "ft";
    IUnitTypes["coords"] = "coords";
})(IUnitTypes || (IUnitTypes = {}));
export var ITextAlignment;
(function (ITextAlignment) {
    ITextAlignment["center"] = "center";
    ITextAlignment["right"] = "right";
    ITextAlignment["left"] = "left";
})(ITextAlignment || (ITextAlignment = {}));
export var IAreaTypes;
(function (IAreaTypes) {
    IAreaTypes["a5"] = "a5";
    IAreaTypes["a4"] = "a4";
    IAreaTypes["a3"] = "a3";
    IAreaTypes["ltr"] = "ltr";
    IAreaTypes["b5"] = "b5";
    IAreaTypes["b4"] = "b4";
    IAreaTypes["pstc"] = "pstc";
    IAreaTypes["bsnc"] = "bsnc";
    IAreaTypes["pstr"] = "pstr";
    IAreaTypes["tbl"] = "tbl";
    IAreaTypes["lghtBx"] = "lghtBx";
    IAreaTypes["blbrd"] = "blbrd";
    IAreaTypes["custom"] = "custom";
})(IAreaTypes || (IAreaTypes = {}));
export var IEventType;
(function (IEventType) {
    IEventType["connect"] = "connect";
    IEventType["connection"] = "connection";
    IEventType["disconnect"] = "disconnect";
    IEventType["pos_doc_changed"] = "pos_doc_changed";
    IEventType["pos_doc_change"] = "pos_doc_change";
    IEventType["selection_changed"] = "selection_changed";
    IEventType["selection_change"] = "selection_change";
    IEventType["selection_removed"] = "selection_removed";
    IEventType["selection_remove"] = "selection_remove";
    IEventType["automerge_update"] = "automerge_update";
    IEventType["users_update"] = "users-update";
    IEventType["users_get"] = "users-get";
})(IEventType || (IEventType = {}));
export var IDocType;
(function (IDocType) {
    IDocType["content_doc"] = "content_doc";
})(IDocType || (IDocType = {}));
export var ILocalStorageKeys;
(function (ILocalStorageKeys) {
    ILocalStorageKeys["displayUnit"] = "displayUnit";
})(ILocalStorageKeys || (ILocalStorageKeys = {}));
export var ITransformProps;
(function (ITransformProps) {
    ITransformProps["scale"] = "scale";
    ITransformProps["position"] = "position";
    ITransformProps["rotation"] = "rotation";
    ITransformProps["scalesInverted"] = "scalesInverted";
    ITransformProps["aspectRatioLocked"] = "aspectRatioLocked";
})(ITransformProps || (ITransformProps = {}));
export var IPublishTypes;
(function (IPublishTypes) {
    IPublishTypes["published"] = "published";
    IPublishTypes["unpublishedChanges"] = "unpublishedChanges";
    IPublishTypes["notPublished"] = "notPublished";
    IPublishTypes["unpublished"] = "unpublished";
})(IPublishTypes || (IPublishTypes = {}));
export var IActionCategory;
(function (IActionCategory) {
    IActionCategory["noAction"] = "noAction";
    IActionCategory["animatePreset"] = "animatePreset";
    IActionCategory["animateModel"] = "animateModel";
    IActionCategory["animateParticle"] = "animateParticle";
    IActionCategory["linkSocial"] = "linkSocial";
    IActionCategory["linkPage"] = "linkPage";
    IActionCategory["linkScene"] = "linkScene";
    IActionCategory["dialNumber"] = "dialNumber";
    IActionCategory["composeEmail"] = "composeEmail";
    IActionCategory["saveContact"] = "saveContact";
    IActionCategory["playSound"] = "playSound";
    IActionCategory["playVideo"] = "playVideo";
    IActionCategory["enlarge"] = "enlarge";
    IActionCategory["takePhoto"] = "takePhoto";
    IActionCategory["toggleVisibility"] = "toggleVisibility";
    IActionCategory["scorm"] = "scorm";
    IActionCategory["multiImageScan"] = "multiImageScan";
    IActionCategory["showArContentScreenRelative"] = "showArContentScreenRelative";
    IActionCategory["showTargetLostPrompt"] = "showTargetLostPrompt";
})(IActionCategory || (IActionCategory = {}));
export var IBtnAndTxtActionCategory;
(function (IBtnAndTxtActionCategory) {
    IBtnAndTxtActionCategory["noAction"] = "noAction";
    IBtnAndTxtActionCategory["linkSocial"] = "linkSocial";
    IBtnAndTxtActionCategory["linkPage"] = "linkPage";
    IBtnAndTxtActionCategory["linkScene"] = "linkScene";
    IBtnAndTxtActionCategory["dialNumber"] = "dialNumber";
    IBtnAndTxtActionCategory["composeEmail"] = "composeEmail";
    IBtnAndTxtActionCategory["saveContact"] = "saveContact";
    IBtnAndTxtActionCategory["playSound"] = "playSound";
    IBtnAndTxtActionCategory["playVideo"] = "playVideo";
})(IBtnAndTxtActionCategory || (IBtnAndTxtActionCategory = {}));
export var IEasing;
(function (IEasing) {
    IEasing["linear"] = "linear";
    IEasing["tie"] = "tie";
    IEasing["smooth"] = "smooth";
    IEasing["accelerating"] = "accelerating";
    IEasing["decelerating"] = "decelerating";
    IEasing["easeInQuad"] = "easeInQuad";
    IEasing["easeOutQuad"] = "easeOutQuad";
    IEasing["easeInOutQuad"] = "easeInOutQuad";
    IEasing["easeInCubic"] = "easeInCubic";
    IEasing["easeOutCubic"] = "easeOutCubic";
    IEasing["easeInOutCubic"] = "easeInOutCubic";
    IEasing["easeInQuart"] = "easeInQuart";
    IEasing["easeOutQuart"] = "easeOutQuart";
    IEasing["easeInOutQuart"] = "easeInOutQuart";
    IEasing["easeInQuint"] = "easeInQuint";
    IEasing["easeOutQuint"] = "easeOutQuint";
    IEasing["easeInOutQuint"] = "easeInOutQuint";
    IEasing["easeInSine"] = "easeInSine";
    IEasing["easeOutSine"] = "easeOutSine";
    IEasing["easeInOutSine"] = "easeInOutSine";
    IEasing["easeInCirc"] = "easeInCirc";
    IEasing["easeOutCirc"] = "easeOutCirc";
    IEasing["easeInOutCirc"] = "easeInOutCirc";
    IEasing["easeInExpo"] = "easeInExpo";
    IEasing["easeOutExpo"] = "easeOutExpo";
    IEasing["easeInOutExpo"] = "easeInOutExpo";
    IEasing["easeInElastic"] = "easeInElastic";
    IEasing["easeOutElastic"] = "easeOutElastic";
    IEasing["easeInOutElastic"] = "easeInOutElastic";
    IEasing["easeInBack"] = "easeInBack";
    IEasing["easeOutBack"] = "easeOutBack";
    IEasing["easeInOutBack"] = "easeInOutBack";
    IEasing["easeOutBounce"] = "easeOutBounce";
    IEasing["easeInBounce"] = "easeInBounce";
    IEasing["easeInOutBounce"] = "easeInOutBounce";
})(IEasing || (IEasing = {}));
